import { getCampaignInfo } from '../utils';

export class ErrorCaughtAdapter {
  buildPayload = eventData => {
    const erroData = this.buildErrorPayload(eventData);

    const { campanha, origemCampanha, utmTerm, utmContent, gclid } = getCampaignInfo();

    const event = {
      eventData: {
        campaignData: {
          campaignId: campanha,
          origin: origemCampanha,
          utmTerm,
          utmContent,
          gclid,
        },
        errorData: { ...erroData },
      },
    };

    return event;
  };

  buildErrorPayload = eventData => {
    const { config, response } = eventData;
    const { url, data } = config;

    const {
      data: { errors },
    } = !response.data.errors
      ? [
          {
            code: response.data.statusCode,
            message: response.data.message,
          },
        ]
      : response;

    const { code, message } = errors[0];

    return {
      code,
      message,
      stack_trace: {
        request_url: url,
        request_data: data != null ? JSON.parse(data) : null,
      },
    };
  };
}

const instance = new ErrorCaughtAdapter();
export default instance;
